import { loadFileFromUrl } from './load-file-from-url';

const saveFileInSessionStorage = (file: File, key: string) => {
  const reader = new FileReader();
  reader.onloadend = (event) => {
    sessionStorage[key] = event.target?.result;
  };
  reader.readAsDataURL(file);
};

const getFileFromSesssionStorage = (key: string, fileName: string) => {
  const fileUrl = sessionStorage.getItem(key);
  if (fileUrl) {
    return loadFileFromUrl(fileUrl, fileName);
  }
  return Promise.resolve(undefined);
};

export { saveFileInSessionStorage, getFileFromSesssionStorage };
